// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen {
  overflow: scroll;
  position: relative;
  height: 50vh;
  background-color: #f1f1f1;
  margin-top: 2.5vw;
}
.screen.fullscreen {
  position: fixed;
  width: 100vw;
  height: 97vh;
  top: 0;
  right: 0;
  z-index: 999;
  padding: 1vh 0;
  margin-top: 6vh;
}
.screen .expand {
  position: absolute;
  top: 2vw;
  right: 1vw;
  cursor: pointer;
  z-index: 999;
}
.screen .bcd {
  width: max-content !important;
  margin: 0 auto;
}
.screen input[type=text] {
  width: 100%;
}
.screen .child,
.screen .child2 {
  position: relative;
}
.screen .child:has(div):before {
  content: "";
  background: #ee3a24;
  position: absolute;
  width: 1px;
  height: 1.4vw;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
}
.screen .child2:has(div):after {
  content: "";
  background: #ee3a24;
  position: absolute;
  width: 1px;
  height: 1.3vw;
  top: -1.5vw;
  left: 50%;
  transform: translateX(-50%);
}
.screen .child > div:after,
.screen .child2 > div:after {
  content: "";
  background: #ee3a24;
  position: absolute;
  width: 1px;
  height: 1.7vw;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
}
.screen .child > div:before {
  content: "";
  background: #ee3a24;
  position: absolute;
  width: 105%;
  height: 1px;
  top: -2px;
}
.screen .child > div:first-child:before {
  content: "";
  background: #ee3a24;
  position: absolute;
  width: 51%;
  height: 1px;
  top: -2px;
  left: 50%;
  transform: translateX(0%);
}
.screen .child > div:last-child:before {
  content: "";
  background: #ee3a24;
  position: absolute;
  width: 51%;
  height: 1px;
  top: -2px;
  right: 50%;
  transform: translateX(0%);
}
.screen button.text-button {
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ee3a24;
  gap: 5px;
  padding: 0.75vw calc(1vw + 20px) 0.75vw 1vw;
  border: 0;
  border-radius: 0.5vw;
  color: #ffe;
  font-weight: 500;
  font-size: 0.95vw;
  line-height: 1vw;
  width: max-content;
  position: relative;
}
.screen button.text-button .dots {
  position: absolute;
  right: 10px;
  cursor: pointer;
  padding: 0 5px;
}
.screen button.text-button.answer {
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.0509803922);
  background: #fff;
  z-index: 4;
  color: #ee3a24;
}
.screen button.text-button.answer path {
  fill: #ee3a24;
}
.screen button.text-button.env {
  border: 1px solid #EE3A24;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.0509803922);
  background: #fff;
  z-index: 4;
  color: #258FBC;
  padding: calc(0.75vw - 1px) calc(1vw + 20px - 1px) calc(0.75vw - 1px) calc(1vw - 1px);
}
.screen button.text-button.env path {
  stroke: #258FBC;
}
.screen .node > div {
  position: relative;
}
.screen .node > div .set-title {
  position: absolute;
  right: 0;
  transform: translateX(calc(100% - 1.5vw));
  padding: 0.75vw;
  background: #fff;
  top: calc(100% + 0.5vw);
  border-radius: 0.3vw;
  width: max-content;
  z-index: 10;
}
.screen .node > div .set-title input {
  display: block;
  border-radius: 0;
  border: 0.5px solid #000;
  padding: 0.4vw;
  font-size: 1vw;
  font-weight: 400;
  margin-bottom: 0.75vw;
}
.screen .node > div .set-title button {
  margin: 0 0 0 auto;
  display: block;
  padding: 0.25vw 0.75vw;
  border: 1px solid #ee3a24;
  border-radius: 0.2vw;
  background-color: #fff;
  color: #ee3a24;
  font-size: 1vw;
  font-weight: 400;
  cursor: pointer;
}
.screen .node > div .select-env {
  position: absolute;
  right: 0;
  transform: translateX(calc(100% - 1.5vw));
  padding: 0.75vw;
  background: #fff;
  top: calc(100% + 0.5vw);
  border-radius: 0.3vw;
  width: max-content;
  z-index: 10;
}
.screen .node > div .select-env p {
  font-size: 1vw;
  color: #000;
  font-weight: 400;
  margin-bottom: 0.25vw;
}
.screen .node > div .select-env select {
  display: block;
  border-radius: 0;
  border: 0.5px solid #000;
  padding: 0.4vw;
  font-size: 1vw;
  font-weight: 400;
  margin-bottom: 0.25vw;
}
.screen .node > div .select-env button {
  margin: 0 0 0 auto;
  display: block;
  padding: 0.25vw 0.75vw;
  border: 1px solid #ee3a24;
  border-radius: 0.2vw;
  background-color: #fff;
  color: #ee3a24;
  font-size: 1vw;
  font-weight: 400;
  cursor: pointer;
}
.screen .node > div .node-action-button {
  position: absolute;
  right: 0;
  transform: translateX(calc(100% - 1.5vw));
  padding: 0.75vw;
  background: #fff;
  top: calc(100% + 0.5vw);
  border-radius: 0.3vw;
  width: 175px;
  z-index: 9;
}
.screen .node > div .node-action-button button {
  width: 100%;
  border: 0;
  font-size: 1vw;
  font-weight: 400;
  padding: 0.5vw 1vw;
  margin-bottom: 0.5vw;
  border-radius: 0.3vw;
  background-color: #fff;
}
.screen .node > div .node-action-button button:disabled {
  border: 0;
  color: #808080;
  cursor: default;
}
.screen .node > div .node-action-button button:hover {
  background-color: #f0f0f0;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/style/components/dashboard/personlisation/Quiz.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACD,YAAA;EACC,yBAAA;EACA,iBAAA;AACJ;AAAI;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAER;AAAI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;AAER;AACI;EACI,6BAAA;EACA,cAAA;AACR;AAEM;EACE,WAAA;AAAR;AAGM;;EAEE,kBAAA;AADR;AAIM;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;AAFR;AAKM;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;AAHR;AAMM;;EAEE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AAJR;AAOM;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AALR;AAQM;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;AANR;AAQM;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;AANR;AAQM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,2CAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AANR;AAOQ;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AALV;AAOQ;EACE,uDAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AALV;AAMU;EACA,aAAA;AAJV;AAOQ;EACE,yBAAA;EACA,uDAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,qFAAA;AALV;AAMU;EACE,eAAA;AAJZ;AAUM;EACE,kBAAA;AARR;AASQ;EACE,kBAAA;EACA,QAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AAPV;AAQU;EACE,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AANZ;AAQU;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AANZ;AAUQ;EACE,kBAAA;EACA,QAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AARV;AASU;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AAPZ;AASU;EACE,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAPZ;AASU;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAPZ;AAWQ;EACE,kBAAA;EACA,QAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,YAAA;EACA,UAAA;AATV;AAUU;EACE,WAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,sBAAA;AARZ;AASY;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAPd;AASY;EACE,yBAAA;EACA,eAAA;AAPd","sourcesContent":[".screen{\n    overflow: scroll;\n    position: relative;\n   height: 50vh;\n    background-color: #f1f1f1;\n    margin-top: 2.5vw;\n    &.fullscreen {\n        position: fixed;\n        width: 100vw;\n        height: 97vh;\n        top: 0;\n        right: 0;\n        z-index: 999;\n        padding: 1vh 0;\n        margin-top: 6vh;\n    }  \n    .expand{\n        position: absolute;\n        top: 2vw;\n        right: 1vw;\n        cursor: pointer;  \n        z-index: 999;       \n      \n    }\n    .bcd {\n        width: max-content !important;\n        margin: 0 auto;\n      }\n      \n      input[type=\"text\"] {\n        width: 100%;\n      }\n      \n      .child,\n      .child2 {\n        position: relative;\n      }\n      \n      .child:has(div):before {\n        content: \"\";\n        background: #ee3a24;\n        position: absolute;\n        width: 1px;\n        height: 1.4vw;\n        top: -20px;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n      \n      .child2:has(div):after {\n        content: \"\";\n        background: #ee3a24;\n        position: absolute;\n        width: 1px;\n        height: 1.3vw;\n        top: -1.5vw;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n      \n      .child > div:after,\n      .child2 > div:after {\n        content: \"\";\n        background: #ee3a24;\n        position: absolute;\n        width: 1px;\n        height: 1.7vw;\n        top: -2px;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n      \n      .child > div:before {\n        content: \"\";\n        background: #ee3a24;\n        position: absolute;\n        width: 105%;\n        height: 1px;\n        top: -2px;\n      }\n      \n      .child > div:first-child:before {\n        content: \"\";\n        background: #ee3a24;\n        position: absolute;\n        width: 51%;\n        height: 1px;\n        top: -2px;\n        left: 50%;\n        transform: translateX(0%);\n      }\n      .child > div:last-child:before {\n        content: \"\";\n        background: #ee3a24;\n        position: absolute;\n        width: 51%;\n        height: 1px;\n        top: -2px;\n        right: 50%;\n        transform: translateX(0%);\n      }\n      button.text-button {\n        min-width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: #ee3a24;\n        gap: 5px;\n        padding: 0.75vw calc(1vw + 20px) 0.75vw 1vw;\n        border: 0;\n        border-radius: 0.5vw;\n        color: #ffe;\n        font-weight: 500;\n        font-size: 0.95vw;\n        line-height: 1vw;\n        width: max-content;\n        position: relative;      \n        .dots {\n          position: absolute;\n          right: 10px;\n          cursor: pointer;\n          padding: 0 5px;\n        }\n        &.answer {\n          box-shadow: 0px 4px 4px 0px #0000000D;\n          background: #fff;\n          z-index: 4;\n          color: #ee3a24;\n          path{\n          fill: #ee3a24;\n        }\n        }\n        &.env {\n          border: 1px solid #EE3A24;\n          box-shadow: 0px 4px 4px 0px #0000000D;\n          background: #fff;\n          z-index: 4;\n          color: #258FBC;\n          padding: calc(0.75vw - 1px) calc(1vw + 20px - 1px) calc(0.75vw - 1px) calc(1vw - 1px);\n          path{\n            stroke: #258FBC;\n          }\n        }\n        \n      }\n      \n      .node > div {\n        position: relative;\n        .set-title {\n          position: absolute;\n          right: 0;\n          transform: translateX(calc(100% - 1.5vw));\n          padding: 0.75vw;\n          background: #fff;\n          top: calc(100% + 0.5vw);\n          border-radius: 0.3vw;\n          width: max-content;\n          z-index: 10;\n          input {\n            display: block;\n            border-radius: 0;\n            border: 0.5px solid #000;\n            padding: 0.4vw;\n            font-size: 1vw;\n            font-weight: 400;\n            margin-bottom: 0.75vw;\n          }\n          button {\n            margin: 0 0 0 auto;\n            display: block;\n            padding: 0.25vw 0.75vw;\n            border: 1px solid #ee3a24;\n            border-radius: 0.2vw;\n            background-color: #fff;\n            color: #ee3a24;\n            font-size: 1vw;\n            font-weight: 400;\n            cursor: pointer;\n          }\n        }\n      \n        .select-env {\n          position: absolute;\n          right: 0;\n          transform: translateX(calc(100% - 1.5vw));\n          padding: 0.75vw;\n          background: #fff;\n          top: calc(100% + 0.5vw);\n          border-radius: 0.3vw;\n          width: max-content;\n          z-index: 10;\n          p {\n            font-size: 1vw;\n            color: #000;\n            font-weight: 400;\n            margin-bottom: 0.25vw;\n          }\n          select {\n            display: block;\n            border-radius: 0;\n            border: 0.5px solid #000;\n            padding: 0.4vw;\n            font-size: 1vw;\n            font-weight: 400;\n            margin-bottom: 0.25vw;\n          }\n          button {\n            margin: 0 0 0 auto;\n            display: block;\n            padding: 0.25vw 0.75vw;\n            border: 1px solid #ee3a24;\n            border-radius: 0.2vw;\n            background-color: #fff;\n            color: #ee3a24;\n            font-size: 1vw;\n            font-weight: 400;\n            cursor: pointer;\n          }\n        }\n      \n        .node-action-button {\n          position: absolute;\n          right: 0;\n          transform: translateX(calc(100% - 1.5vw));\n          padding: 0.75vw;\n          background: #fff;\n          top: calc(100% + 0.5vw);\n          border-radius: 0.3vw;\n          width: 175px;\n          z-index: 9;\n          button {\n            width: 100%;\n            border: 0;\n            font-size: 1vw;\n            font-weight: 400;\n            padding: 0.5vw 1vw;\n            margin-bottom: 0.5vw;\n            border-radius: 0.3vw;\n            background-color: #fff;\n            &:disabled {\n              border: 0;\n              color: #808080;\n              cursor: default;\n            }\n            &:hover {\n              background-color: #f0f0f0;\n              cursor: pointer;\n            }\n          }\n        }\n      }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
